import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { BRAND } from '../constants/brand';
import logoMark from '../assets/new_theme.png';

const navLinks = [
  { label: 'Services', id: 'services' },
  { label: 'Why Us', id: 'why-us' },
  { label: 'How We Work', id: 'process' },
  { label: 'Testimonials', id: 'testimonials' },
  { label: 'Contact', id: 'contact' },
];

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const go = (id: string) => {
    setOpen(false);
    if (pathname !== '/') {
      window.location.href = `/#${id}`;
      return;
    }
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/90 backdrop-blur-xl border-b border-slate-200/80 shadow-nav'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between min-h-[4rem] md:min-h-[4.25rem]">
        <Link to="/" className="flex items-center gap-3 group">
          <img
            src={logoMark}
            alt={BRAND.logoAlt}
            className="h-9 w-9 md:h-10 md:w-10 rounded-xl ring-1 ring-slate-200/80 shadow-sm object-contain bg-white"
            width={40}
            height={40}
          />
          <div className="flex flex-col leading-tight">
            <span className="font-display font-semibold text-slate-900 text-lg tracking-tight group-hover:text-brand-violet transition-colors">
              {BRAND.displayName}
            </span>
            <span className="text-[11px] md:text-xs text-slate-500 font-medium uppercase tracking-wider">
              {BRAND.tagline}
            </span>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          <Link
            to="/products"
            className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
          >
            Apps
          </Link>
          {navLinks.map((l) => (
            <button
              key={l.id}
              type="button"
              onClick={() => go(l.id)}
              className="px-4 py-2 text-sm font-medium text-slate-600 hover:text-slate-900 transition-colors"
            >
              {l.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => go('contact')}
            className="ml-2 px-5 py-2 rounded-full text-sm font-semibold bg-gradient-brand text-white shadow-brand hover:opacity-95 transition-opacity"
          >
            Start a project
          </button>
        </nav>

        <button
          type="button"
          className="md:hidden p-2 text-slate-700"
          aria-label="Menu"
          onClick={() => setOpen(!open)}
        >
          {open ? <FiX size={24} /> : <FiMenu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-slate-200 bg-white/98 backdrop-blur-xl px-4 py-4 flex flex-col gap-1 shadow-nav">
          <Link
            to="/products"
            onClick={() => setOpen(false)}
            className="text-left py-3 text-slate-700 font-medium"
          >
            Apps
          </Link>
          {navLinks.map((l) => (
            <button
              key={l.id}
              type="button"
              onClick={() => go(l.id)}
              className="text-left py-3 text-slate-700 font-medium"
            >
              {l.label}
            </button>
          ))}
          <button
            type="button"
            onClick={() => go('contact')}
            className="mt-2 py-3 rounded-xl font-semibold bg-gradient-brand text-white shadow-brand"
          >
            Start a project
          </button>
        </div>
      )}
    </header>
  );
};

export default Navbar;
